export const equipmentCheckZh = {
  BloomEquipment001: '进入调试',
  BloomEquipment002: '设备调试',
  BloomEquipment003: '欢迎来到设备调试页面，在这里你可以检查当前设备的调试状态，判断能否顺利参与考试，提前解决问题！调试过程中如若遇到无法解决的问题请联系校园合作老师或者活动官方邮箱。',
  BloomEquipment004: '目前考试只兼容Google浏览器，所以在进入设备调试前需要检查你当前使用的浏览器。',
  BloomEquipment005: '当前浏览器：',
  BloomEquipment006: '请使用版本在80以上的Google浏览器进入设备调试页面，',
  BloomEquipment007: '前往下载',
  BloomEquipment008: '当前设备调试一切正常，预祝考试顺利',
  BloomEquipment009: '请在正式考试中使用当前调试所用设备，如若更换设备，请使用新的设备重新进行设备调试以确保能够顺利参与考试。',
  BloomEquipment010: '返回任务列表',
  BloomEquipment011: '摄像头&麦克风',
  BloomEquipment012: '扬声器',
  BloomEquipment013: '共享屏幕',
  BloomEquipment014: '手机摄像头',
  BloomEquipment015: '摄像头和麦克风将用于考试中的身份核验和摄像头监考，请确保摄像头能够拍摄到你的正面。',
  BloomEquipment037: '摄像头将用于考试中的身份核验和摄像头监考，请确保摄像头能够拍摄到你的正面。',
  BloomEquipment016: '下一步',
  BloomEquipment017: '上一步',
  BloomEquipment018: '调试状态',
  BloomEquipment019: '正常',
  BloomEquipment020: '异常',
  BloomEquipment021: '若调试失败，请点击下方按钮重启摄像头和麦克风',
  BloomEquipment038: '若调试失败，请点击下方按钮重启摄像头',
  BloomEquipment022: '启用摄像头和麦克风',
  BloomEquipment039: '启用摄像头',
  BloomEquipment023: '调试正常，下一步',
  BloomEquipment024: '扬声器用于考试中的音频题目（如有），请调高音量播放下方音频以确保当前设备能够播放声音。',
  BloomEquipment025: '需自行判断能否听见声音，若听不到声音，请外接音箱或者更换电脑设备',
  BloomEquipment026: '摄像头',
  BloomEquipment027: '扬声器用于考试中的音频题目（如有），请调高音量播放下方音频以确保当前设备能够播放声音。',
  BloomEquipment028: '需自行判断能否听见声音，若听不到声音，请外接音箱或者更换电脑设备',
  BloomEquipment029: '共享屏幕将用于考试中的电脑屏幕监考，请共享当前页面的整个屏幕。',
  BloomEquipment030: '请共享你的屏幕，确保电脑屏幕监考正常',
  BloomEquipment031: '共享屏幕',
  BloomEquipment032: '手机调试将用于考试中的手机监考，请确保手机拥有前置摄像头且能够正常使用。',
  BloomEquipment033: '调试状态：',
  BloomEquipment034: '请使用手机微信或QQ扫码连接手机摄像头',
  BloomEquipment035: '选择摄像头和麦克风：',
  BloomEquipment036: '选择摄像头：',
  BloomEquipment040: 'https://img.webloom.cn/img/equipment019.png',
  BloomEquipment041: '调试完成'

}

export const equipmentCheckEn = {
  BloomEquipment001: 'Enter',
  BloomEquipment002: 'Technical Test',
  BloomEquipment003: 'Welcome to the Technical Test. Here, you can check if your devices meet the requirement of the exams. If you encounter technical issues, please contact us by your campus cooperation teacher or the organizing committee email.',
  BloomEquipment004: 'ONLY Google Chrome browser is fully compatible for the exams for now. Therefore, before entering the Technical Test, please check the browser you are currently using.',
  BloomEquipment005: 'Current browser:',
  BloomEquipment006: 'Please use the Google Chrome browser with a version of 80 or higher to conduct the test. ',
  BloomEquipment007: 'Go to download.',
  BloomEquipment008: 'Current devices and systems are qualified for an exam. Good luck!',
  BloomEquipment009: 'In the official exams, please use the exact devices you are using. If you replace the devices, please take another Technical Test to ensure the new device(s) is/are qualified.',
  BloomEquipment010: 'Return to task list.',
  BloomEquipment011: 'Computer Camera and Microphone',
  BloomEquipment012: 'Speaker',
  BloomEquipment013: 'Computer Screen Sharing',
  BloomEquipment014: 'Mobile Phone Camera',
  BloomEquipment015: 'The camera and microphone will be used for identity verification and monitoring during the exam. Please ensure that the camera can capture your face from the front.',
  BloomEquipment037: 'The camera will be used for identity verification and monitoring during the exam. Please ensure that the camera can capture your face from the front.',
  BloomEquipment016: 'Next',
  BloomEquipment017: 'Back',
  BloomEquipment018: 'Testing Status',
  BloomEquipment019: 'Successful',
  BloomEquipment020: 'Error',
  BloomEquipment021: 'If the test fails, please click the button below to restart camera and microphone.',
  BloomEquipment038: 'If the test fails, please click the button below to restart camera.',
  BloomEquipment022: 'Enable camera and microphone.',
  BloomEquipment039: 'Enable camera.',
  BloomEquipment023: 'Successful. Next step',
  BloomEquipment024: 'The speaker will be used for the audio questions (if any) during the exam. Please turn up the volume and play the audio below to check if the current device speaker functions well.',
  BloomEquipment025: 'Please check if you can hear the audio loud and clear. If you cannot hear any sound, please use an external speaker or replace the computer to have another try.',
  BloomEquipment026: 'Camera',
  BloomEquipment027: 'The speaker will be used for the audio questions (if any) during the exam. Please turn up the volume and play the audio below to check if the current device speaker functions well.',
  BloomEquipment028: 'Please check if you can hear the audio loud and clear. If you cannot hear any sound, please use an external speaker or replace the computer to have another try.',
  BloomEquipment029: 'The screen sharing will be used for the computer screen invigilation during the exam. Please share the entire screen.',
  BloomEquipment030: 'Please share your screen to ensure that the computer screen is properly proctored.',
  BloomEquipment031: 'Share computer screen',
  BloomEquipment032: 'The camera of mobile phone will be used for the real time invigilation during the exam. Please ensure that it has a functional front camera.',
  BloomEquipment033: 'Debugging Status:',
  BloomEquipment034: 'Please use WeChat or QQ on your mobile phone to scan the QR code for connecting to the mobile phone camera.',
  BloomEquipment035: 'Select camera and microphone:',
  BloomEquipment036: 'Select camera:',
  BloomEquipment040: 'https://img.webloom.cn/img/equipment036.png',
  BloomEquipment041: 'Finish'
}



// WEBPACK FOOTER //
// ./src/i18n/langs/proctor/equipmentCheck.js